/*
  Interactiviteit voor de FitTowel-winkelwagen: de compacte aantal-stepper
  (getal + omhoog/omlaag-pijltjes) stuurt automatisch het winkelwagen-
  formulier opnieuw in, zodat Shopify de aantallen/subtotalen/totalen
  server-side herberekent — geen eigen rekenwerk dat uit de pas kan lopen.
  De kortingscode gaat via de officiële Cart AJAX API.
*/

if (!customElements.get('ft-cart-quantity')) {
  customElements.define(
    'ft-cart-quantity',
    class FtCartQuantity extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-cart-qty-input]');
        this.up = this.querySelector('[data-cart-qty-up]');
        this.down = this.querySelector('[data-cart-qty-down]');
        this.form = this.closest('form');
        if (!this.input || !this.form) return;

        this.onUp = () => this.step(1);
        this.onDown = () => this.step(-1);

        this.up?.addEventListener('click', this.onUp);
        this.down?.addEventListener('click', this.onDown);
        this.input.addEventListener('change', () => this.form.requestSubmit());
      }

      step(direction) {
        const min = Number(this.input.min) || 0;
        const current = Number(this.input.value) || 0;
        this.input.value = Math.max(min, current + direction);
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[ft-discount-form]');
  if (!form) return;

  event.preventDefault();

  const input = form.querySelector('input[name="discount"]');
  const message = form.parentElement.querySelector('[data-discount-message]');
  const code = input?.value.trim();
  if (!code) return;

  const submitButton = form.querySelector('button[type="submit"]');
  if (submitButton) submitButton.disabled = true;

  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code }),
    });
    const cart = await response.json();

    const applied = cart.cart_level_discount_applications || [];
    const matched = applied.some((discount) =>
      discount.title?.toLowerCase().includes(code.toLowerCase())
    );

    if (matched || applied.length > 0) {
      window.location.reload();
      return;
    }

    if (message) {
      message.textContent = 'Deze kortingscode is niet geldig.';
      message.hidden = false;
    }
  } catch (error) {
    if (message) {
      message.textContent = 'Kon de kortingscode niet toepassen. Probeer het opnieuw.';
      message.hidden = false;
    }
  } finally {
    if (submitButton) submitButton.disabled = false;
  }
});
